import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { ProgressBar } from "primereact/progressbar";
import { Badge } from "primereact/badge";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { TabView, TabPanel } from "primereact/tabview";
import { FileUpload } from "primereact/fileupload";
import { addLocale } from "primereact/api";
import { Calendar } from "primereact/calendar";
import classNames from "classnames";
import { Toast } from "primereact/toast";
import { loading, setUsuarioLogin } from "../../actions";
import { getLista, getListaGrado } from "../../service/FichaEstudiante";
import { setUploadFoto, getPersona, updatePersona, updatePersonaApoderado, updatePersonaGlosa } from "../../service/Persona";
import { getDiagnostico, RegistroMatricula, getImportarAlumnos, getImportarAlumnosPrePri } from "../../service/Matricula";
import { Image } from "primereact/image";
import { useDispatch, useSelector } from "react-redux";
import { InputTextarea } from "primereact/inputtextarea";
import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import { FiltroNivelCurso } from "../../components/FiltroNivelCurso";
import "./StepsDemo.css";
import { isNotVacioNull, isEmail, isRun, isLetras, isLetrasEspacio, minMax, isValue, isTelefono, getResultValidar } from "../../utilities/Validate";
import * as XLSX from 'xlsx';
import { useHistory } from "react-router-dom";
import { accionPermiso } from "../../utilities/Seguridad";
import { Tooltip } from "primereact/tooltip";
import { ScrollPanel } from "primereact/scrollpanel";
import { Tag } from "primereact/tag";
import { FixedSizeList as List } from 'react-window'; // Importa react-window

export const PageFicha = () => {
    const [dataFicha, setDataFicha] = useState(null);
    const [dataFichaFilter, setDataFichaFilter] = useState(null);
    const [selectedFicha, setSelectedFicha] = useState(null);
    const [globalFilter1, setGlobalFilter1] = useState("");
    const [loading1, setLoading1] = useState(false);

    const [page, setValuePage] = useState(8);
    const [activeIndex, setActiveIndex] = useState(0);

    const [valueFechaNacimiento, setValueFechaNacimiento] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [submittedApo, setSubmittedApo] = useState(false);
    const [submittedObse, setSubmittedObse] = useState(false);

    const [personaEdita, setPersonaEdita] = useState({});

    const [displayResponsive, setDisplayResponsive] = useState(false);
    const [displayResponsivePri, setDisplayResponsivePri] = useState(false);
    const [displayResponsivePre, setDisplayResponsivePre] = useState(false);
    const [array, setArray] = useState([]);
    const [subir, setSubir] = useState(false);

    const toast = useRef(null);
    const fileUpload = useRef(null);

    // Reset Filtros Curso y grado
    const filtroRef = useRef(null);

    const dispatch = useDispatch();
    const [selectedAutoValue, setSelectedAutoValue] = useState(null);
    const [btnMatricular, setBtnMatricular] = useState(true);
    const [labelCountMatricular, setLabelCountMatricular] = useState("0");

    //Dialog Matricula
    const [dataMatricula, setDataMatricula] = useState(null);
    const [dataMatriculaSend, setDataMatriculaSend] = useState([]);
    const [originalRows, setOriginalRows] = useState({});
    const [dialogMatricula, setDialogMatricula] = useState(false);
    const [neeArray, setNeeArray] = useState([]);
    const [diagArray, setDiagArray] = useState([]);
    const [diagArrayFilter, setDiagArrayFilter] = useState([]);

    const [regiones, setRegiones] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [comunas, setComunas] = useState([]);

    const [regionesApo, setRegionesApo] = useState([]);
    const [provinciasApo, setProvinciasApo] = useState([]);
    const [comunasApo, setComunasApo] = useState([]);
    const [glosa, setGlosa] = useState({ glosa: "", idalumno: null, idmatricula: null });
    const [glosaValidacion, setGlosaValidacion] = useState(false);

    let DatosPersonales = {
        id: null,
        pais: "",
        run: "",
        nombres: "",
        apellido_paterno: "",
        apellido_materno: "",
        genero: "",
        region: "",
        provincia: "",
        comuna: "",
        direccion: "",
        email: "",
        telefono: "",
        fecha_nacimiento: "16/03/2022",
        edad: "",
        idioma: "",
        etnia: "",
        fecha_ingreso: "",
        fecha_retiro: "",
        foto: "assets/layout/images/fotovacio.png",
        preferente: false,
        prioritario: false

    };

    let DatosPersonalesValidate = {
        id: { estado: null, mensaje: "", validar: isValue, minmax: false },
        pais: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        run: { estado: null, mensaje: "Error formato run", validar: isRun, minmax: false },
        nombres: { estado: null, mensaje: "Valor requerido letras con longitud max. 45", validar: isLetrasEspacio, minmax: true, min: 1, max: 45 },
        apellido_paterno: { estado: null, mensaje: "Valor requerido letras con longitud max. 45", validar: isLetras, minmax: true, min: 1, max: 45 },
        apellido_materno: { estado: null, mensaje: "Valor requerido letras con longitud max. 45", validar: isLetras, minmax: true, min: 1, max: 45 },
        genero: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        region: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        provincia: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        comuna: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        direccion: { estado: null, mensaje: "Valor requerido con longitud max. 100", validar: isNotVacioNull, minmax: true, min: 1, max: 200 },
        email: { estado: null, mensaje: "Error formato email con longitud max. 45", validar: isValue, minmax: true, min: 1, max: 45 },
        telefono: { estado: null, mensaje: "Error formato con longitud min. 9,max. 12", validar: isTelefono, minmax: true, min: 1, max: 12 },
        fecha_nacimiento: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        edad: { estado: null, mensaje: "", validar: isValue, minmax: false },
        idioma: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        etnia: { estado: null, mensaje: "Valor requerido", validar: isValue, minmax: false },
        fecha_ingreso: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        fecha_retiro: { estado: null, mensaje: "Valor requerido", validar: isValue, minmax: false },
        foto: { estado: null, mensaje: "", validar: isValue, minmax: false },
    };

    let DatosPersonalesApo = {
        run: "",
        nombres: "",
        apellido_paterno: "",
        apellido_materno: "",
        direccion: "",
        email: "",
        fecha_nacimiento: "16/03/2022",
        idalumno: "",
        idapoderado: "",
        comuna: "",
        parentesco: "",
        provincia: "",
        region: "",
        telefono1: "",
        telefono2: "",
        numero_emergencia: "",
        edad: "",
    };

    let DatosPersonalesApoValid = {
        run: { estado: true, mensaje: "Error formato run", validar: isRun, minmax: false },
        nombres: { estado: true, mensaje: "Valor requerido letras con longitud max. 45", validar: isLetrasEspacio, minmax: true, min: 1, max: 45 },
        apellido_paterno: { estado: true, mensaje: "Valor requerido letras con longitud max. 45", validar: isLetras, minmax: true, min: 1, max: 45 },
        apellido_materno: { estado: true, mensaje: "Valor requerido letras con longitud max. 45", validar: isLetras, minmax: true, min: 1, max: 45 },
        direccion: { estado: true, mensaje: "Valor requerido con longitud max. 100", validar: isNotVacioNull, minmax: true, min: 1, max: 200 },
        email: { estado: true, mensaje: "Error formato email con longitud max. 45", validar: isValue, minmax: true, min: 1, max: 45 },
        fecha_nacimiento: { estado: true, mensaje: "Valor requerido", validar: isValue, minmax: false },
        idalumno: { estado: true, mensaje: "", validar: isValue, minmax: false },
        idapoderado: { estado: true, mensaje: "", validar: isValue, minmax: false },
        comuna: { estado: true, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        parentesco: { estado: true, mensaje: "Valor requerido", validar: isValue, minmax: false },
        provincia: { estado: true, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        region: { estado: true, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        telefono1: { estado: true, mensaje: "Error formato con longitud min. 9,max. 12", validar: isTelefono, minmax: true, min: 1, max: 12 },
        telefono2: { estado: true, mensaje: "Error formato con longitud min. 9,max. 12", validar: isValue, minmax: false },
        numero_emergencia: { estado: true, mensaje: "Error formato con longitud min. 9,max. 12", validar: isValue, minmax: false },
        edad: { estado: true, mensaje: "", validar: isValue, minmax: false },
    };

    const [personales, setPersonales] = useState(DatosPersonales);
    const [personalesValidate, setPersonalesValidate] = useState(DatosPersonalesValidate);

    const [personalesApo, setPersonalesApo] = useState(DatosPersonalesApo);
    const [personalesApoValidate, setPersonalesApoValidate] = useState(DatosPersonalesApoValid);

    const [detalleDialog, setDetalleDialog] = useState(false);

    const generoArray = [
        { name: "MASCULINO", code: "M" },
        { name: "FEMENINO", code: "F" },
    ];

    const ver = useRef(false);

    // Permisos
    const history = useHistory();
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    try {
        permisos.current.superusuario = usuario.superusuario;
        permisos.current.acciones = usuario.permisos.registros.ficha_estudiante.acciones;
    } catch (error) {
        permisos.current.acciones = [];
    }
    //----------------------------

    const onclikMatricular = () => {
        let dataMat = [];

        for (let i = 0; selectedFicha.length > i; i++) {
            dataMat[i] = {
                id_ficha: selectedFicha[i]["id"],
                //id_grado: selectedFicha[i]['idgrado'],
                r: selectedFicha[i]["rbd"],
                gr: selectedFicha[i]["grado"],
                no: selectedFicha[i]["nombres"],
                pa: selectedFicha[i]["apellido_paterno"],
                ma: selectedFicha[i]["apellido_materno"],
                nee: { tipo_nee: "--", idtipo_nee: 0 },
                diag: { diagnostico: "--", iddiagnostico: 0, idtipo_nee: 0 },
                obs: "",
                adi: false,
                edit: false,
            };
        }
        setDataMatricula(dataMat);
        setDialogMatricula(true);
    };

    const monthNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} style={{ lineHeight: 1 }} />;
    };

    const yearNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} className="ml-2" style={{ lineHeight: 1 }} />;
    };

    addLocale("es", {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
        today: "Hoy",
        clear: "Claro",
    });

    useEffect(() => {
        if (accionPermiso(permisos, "ficha_ver")) {
            loadDiagnostico();
        }
    }, []);

    const getFiltroNivelCurso = useCallback(
        (data) => {
            if (data.es_nivel) {
                if (data.idnivel == 0) {
                    setDataFichaFilter(dataFicha);
                } else {
                    setDataFichaFilter(dataFicha.filter((o) => o.idnivel == data.idnivel));
                }
            } else {
                if (data.id == 0) {
                    setDataFichaFilter(dataFicha.filter((o) => o.idnivel == data.idnivel));
                } else {
                    setDataFichaFilter(dataFicha.filter((o) => o.idgrado == data.id &&
                        o.idnivel == data.idnivel));
                }
            }
            setSelectedFicha(null);
            accionButtonMatricular(0);
        },
        [dataFichaFilter]
    );

    useEffect(() => {
        if (accionPermiso(permisos, "ficha_ver")) {
            loadFicha();
        } else {
            history.push("/Acceso");
        }

        //window.addEventListener('resize',loadd);

        // return()=>{ window.removeEventListener('resize',loadd);}
    }, [anio]);

    useEffect(() => {
        if (personales.region !== undefined && personales.region !== "") {
            setProvincias(usuario.general.provincia.filter((o) => o.idregion == personales.region.idregion));
            setComunas([]);
        } else {
            setProvincias([]);
            setComunas([]);
            let _ubigeo = { ...personales };
            _ubigeo["provincia"] = "";
            _ubigeo["comuna"] = "";
            setPersonales(_ubigeo);
        }
    }, [personales.region]);

    useEffect(() => {
        if (personales.provincia !== undefined && personales.provincia !== "") {
            setComunas(usuario.general.comuna.filter((o) => o.idprovincia == personales.provincia.idprovincia));
        } else {
            setComunas([]);
            let _ubigeo = { ...personales };
            _ubigeo["comuna"] = "";
            setPersonales(_ubigeo);
        }
    }, [personales.provincia]);

    useEffect(() => {
        if (personalesApo.region !== undefined && personalesApo.region !== "") {
            setProvinciasApo(usuario.general.provincia.filter((o) => o.idregion == personalesApo.region.idregion));
            setComunasApo([]);
        } else {
            setProvinciasApo([]);
            setComunasApo([]);
            let _ubigeo1 = { ...personalesApo };
            _ubigeo1["provincia"] = "";
            _ubigeo1["comuna"] = "";
            setPersonalesApo(_ubigeo1);
        }
    }, [personalesApo.region]);

    useEffect(() => {
        if (personalesApo.provincia !== undefined && personalesApo.provincia !== "") {
            setComunasApo(usuario.general.comuna.filter((o) => o.idprovincia == personalesApo.provincia.idprovincia));
        } else {
            setComunasApo([]);
            let _ubigeo2 = { ...personalesApo };
            _ubigeo2["comuna"] = "";
            setPersonalesApo(_ubigeo2);
        }
    }, [personalesApo.provincia]);

    const loadFicha = async () => {
        //sleep(1).then(async r => {//Código que pausado
        //})

        if (colegio.id !== undefined && anio.anio !== undefined) {
            dispatch(loading(true));
            filtroRef.current.click();
            var data = await getLista(colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                setDataFicha(data.ficha_estudiantes);
                setDataFichaFilter(data.ficha_estudiantes);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }

            dispatch(loading(false));
        } else {
            setDataFicha([]);
            setDataFichaFilter([]);
        }

        setSelectedFicha(null);
        accionButtonMatricular(0);
    };

    const loadDiagnostico = async () => {
        dispatch(loading(true));

        var data = await getDiagnostico(usuario.token);
        if (data.error == 0) {
            setNeeArray(data.tipo_nee);
            setDiagArray(data.diagnostico);
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }

        dispatch(loading(false));
    };

    const hideDialog = () => {
        ver.current = false;
        setSubmitted(false);
        setSubmittedApo(false);
        setSubmittedObse(false);
        setDetalleDialog(false);
    };

    const sleep = (seconds) => {
        var milliseconds = 1000 * seconds;
        return new Promise((resolve) => setTimeout(resolve, milliseconds));
    };

    const exportExcel = () => {
        let dataExportar = [];
        dataFichaFilter?.map((obj) => {
            let o = { ...obj };
            delete o.id;
            delete o.idalumno;
            delete o.digito_verificador;
            delete o.idmatriculapie;
            dataExportar.push(o);
        });

        import("xlsx").then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(dataExportar);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
            saveAsExcelFile(excelBuffer, "Fichas");
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((FileSaver) => {
            let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            let EXCEL_EXTENSION = ".xlsx";
            const data = new Blob([buffer], {
                type: EXCEL_TYPE,
            });
            FileSaver.saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
        });
    };

    const header = (
        <div className="table-header">
            <div className="p-formgrid p-grid p-col-12 p-fluid p-p-0">
                <div className="p-col-12 p-md-6 p-lg-2 p-mt-5">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)} className="p-mr-3" placeholder="Buscar..." />
                    </span>
                </div>

                <div className="p-col-12 p-md-6 p-lg-3">{accionPermiso(permisos, "ficha_ver") ? <FiltroNivelCurso getFiltroNivelCurso={getFiltroNivelCurso} reset={filtroRef} /> : ""}</div>
                <div className="p-col-12 p-md-6 p-lg-2 p-mt-4" style={{ paddingTop: "5px" }}>
                    {" "}
                    {accionPermiso(permisos, "ficha_matricular") ? (
                        <Button type="button" label="MATRICULAR" icon="pi pi-check" disabled={btnMatricular} onClick={onclikMatricular}>
                            <Badge value={labelCountMatricular}></Badge>
                        </Button>
                    ) : (
                        ""
                    )}
                </div>

                <div className="p-col-12 p-md-6 p-lg-5 p-mt-4" style={{ textAlign: "right" }}>
                    {accionPermiso(permisos, "ficha_exportar") ? <Button type="button" icon="pi pi-file-excel" onClick={exportExcel} className="p-button-success mr-2 p-mr-1" tooltip="Descargar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }} /> : ""}
                    <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadFicha} tooltip="Actualizar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button>
                    {accionPermiso(permisos, "ficha_importar_masivo") ? <Button type="button" icon="pi pi-upload" className="p-button-success mr-2" style={{ marginLeft: "3px" }} onClick={() => dialogUpload()} tooltip="Matricula" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button> : ""}
                    {accionPermiso(permisos, "ficha_importar_masivo") ? <Button type="button" icon="pi pi-upload" className="p-button-warning mr-2" style={{ marginLeft: "3px",backgroundColor: "#F39C12", border: "1px solid #F39C12", color: "#000000" }} onClick={() => dialogUploadPrioritario()} tooltip="Prioritario" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button> : ""}
                    {accionPermiso(permisos, "ficha_importar_masivo") ? <Button type="button" icon="pi pi-upload" className="p-button-help mr-2" style={{ marginLeft: "3px" }} onClick={() => dialogUploadPreferente()} tooltip="Preferente" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button> : ""}

                </div>
            </div>
        </div>
    );

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const bodyTemplateDate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field] === null ? "--" : moment(data[props.field]).format("DD/MM/YYYY")}
            </>
        );
    };

    const bodyTemplateDrow = () => {
        return (
            <>
                <Dropdown value={personales.pais} options={countries} onChange={(e) => onInputChange(e, "pais")} optionLabel="name" filter showClear filterBy="name" placeholder="Seleccionar..." />
            </>
        );
    };

    const bodyTemplate100 = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const onEditorValueChangeMatri = (props, value) => {
        let updatedProducts = [...props.value];
        updatedProducts[props.rowIndex][props.namecol] = value;
        updatedProducts[props.rowIndex]["edit"] = true;
        setDataMatricula(updatedProducts);

        if (props.namecol === "nee") {
            setDiagArrayFilter(diagArray.filter((o) => o.idtipo_nee == value.idtipo_nee));
        }
    };

    const checkEditorS = (options) => {
        return (
            <>
                <InputSwitch checked={options.rowData[options.field]} onChange={(e) => onEditorValueChangeMatri(options, e.value)} />
            </>
        );
    };

    const checkEditor = (data, options) => {
        return (
            <>
                <InputSwitch checked={options.rowData[options.field]} disabled onChange={(e) => onEditorValueChangeMatri(options, e.value)} />
            </>
        );
    };

    const textEditor = (options) => {
        return <InputText type="text" value={options.rowData[options.field]} onChange={(e) => onEditorValueChangeMatri(options, e.target.value)} />;
    };

    const drowEditorTipoNee = (options) => {
        return (
            <Dropdown
                value={options.rowData[options.namecol]}
                options={neeArray}
                optionLabel="tipo_nee"
                //optionValue="code"
                onChange={(e) => onEditorValueChangeMatri(options, e.target.value)}
                style={{ width: "100%" }}
                placeholder="--Seleccionar-"
                itemTemplate={(option) => {
                    return <span className={`product-badge status-${option.tipo_nee}`}>{option.tipo_nee}</span>;
                }}
            />
        );
    };

    const drowEditorDiag = (options) => {
        return (
            <Dropdown
                value={options.rowData[options.namecol]}
                options={diagArray.filter((o) => o.idtipo_nee == options.rowData.nee.idtipo_nee)}
                optionLabel="diagnostico"
                //optionValue="code"
                onChange={(e) => onEditorValueChangeMatri(options, e.target.value)}
                style={{ width: "100%" }}
                placeholder="--Seleccionar-"
                itemTemplate={(option) => {
                    return <span className={`product-badge status-${option.diagnostico}`}>{option.diagnostico}</span>;
                }}
            />
        );
    };

    const updatePersonaView = async (tipo) => {
        if (tipo == 0) {
            await updatePersonaApi();
        }
        if (tipo == 1) {
            await updatePersonaApoApi();
        }
        if (tipo == 2) {
            await updatePersonaG();
        }
    };

    const updatePersonaG = async () => {
        setSubmittedObse(true);
        let resul = isNotVacioNull(glosa.glosa, true, 1, 300);
        setGlosaValidacion(true);
        // if (resul) {

        dispatch(loading(true));
        var data = await updatePersonaGlosa(glosa, usuario.token);
        if (data.error == 0) {
            toast.current.show({ severity: "success", summary: "OK", detail: "Glosa actualizada!", life: 3000 });
            hideDialog();
            // loadFicha();
        } else {
            if (data.error == 1) {
                let detalle = "";
                if (data.validacion !== undefined) {
                    data.validacion?.map((value, index) => {
                        detalle = detalle + value.key + ", ";
                    });
                }

                toast.current.show({ severity: "error", summary: "Error" + data.mensaje, detail: detalle, life: 3000 });
            } else {
                console.log("Error");
            }
        }
        dispatch(loading(false));
        //   }
    };

    const updatePersonaApi = async () => {
        if (!(JSON.stringify(personales) === JSON.stringify(personaEdita))) {
            setSubmitted(true);

            let validado = getResultValidar(personales, personalesValidate);

            setPersonalesValidate(validado.result);

            if (validado.registra) {
                dispatch(loading(true));
                var data = await updatePersona(personales, usuario.token);
                if (data.error == 0) {
                    toast.current.show({ severity: "success", summary: "OK", detail: "Registro del estudiante actualizado!", life: 3000 });
                    hideDialog();
                    loadFicha();
                } else {
                    if (data.error == 1) {
                        let detalle = "";
                        if (data.validacion !== undefined) {
                            data.validacion?.map((value, index) => {
                                detalle = detalle + value.key + ", ";
                            });
                        }

                        toast.current.show({ severity: "error", summary: "Error" + data.mensaje, detail: detalle, life: 3000 });
                    } else {
                        console.log("Error");
                    }
                }
                dispatch(loading(false));
            }
        } else {
            toast.current.show({ severity: "info", summary: "Información", detail: "No realizo modificaciones!", life: 3000 });
        }
    };

    const updatePersonaApoApi = async () => {
        setSubmittedApo(true);

        let validado = getResultValidar(personalesApo, personalesApoValidate);

        setPersonalesApoValidate(validado.result);

        if (validado.registra) {
            dispatch(loading(true));
            var data = await updatePersonaApoderado(personalesApo, usuario.token);
            if (data.error == 0) {
                toast.current.show({ severity: "success", summary: "OK", detail: "Registro del apoderado actualizado!", life: 3000 });
                hideDialog();
                loadFicha();
            } else {
                if (data.error == 1) {
                    let detalle = "";
                    if (data.validacion !== undefined) {
                        data.validacion?.map((value, index) => {
                            detalle = detalle + value.key + ", ";
                        });
                    }

                    toast.current.show({ severity: "error", summary: "Error" + data.mensaje, detail: detalle, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
            dispatch(loading(false));
        }
    };

    const productDialogFooter = (
        <>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            {ver.current ? "" : <Button label="Actualizar" icon="pi pi-check" onClick={() => updatePersonaView(activeIndex)} />}
        </>
    );

    const statusBodyTemplate = (data) => {
        return (
            <>
                <span className="p-column-title">Status</span>
                <span className={`customer-badge status-${data.status}`}>{data.status}</span>
            </>
        );
    };

    const activityBody = (data) => {
        return (
            <>
                <span className="p-column-title">Activity</span>
                <ProgressBar value={data.activity} showValue={false} />
            </>
        );
    };

    const countries = usuario.general.pais;

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || "";
        let _detalla = { ...personales };
        _detalla[`${name}`] = val;

        if (name == "fecha_nacimiento") {
            let naci = moment(val);
            let hoy = moment(new Date());
            _detalla["edad"] = (isNaN(hoy.diff(naci, "year")) ? '' : hoy.diff(naci, "year"));
            var vvv = moment(_detalla["edad"]).format("YYYY-MM-DD");
        }

        var ff = selectedAutoValue;

        setPersonales(_detalla);
    };

    const onInputChangeApo = (e, name) => {
        const val = (e.target && e.target.value) || "";
        let _detalla = { ...personalesApo };
        _detalla[`${name}`] = val;

        if (name == "fecha_nacimiento") {
            let naci = moment(val);
            let hoy = moment(new Date());
            _detalla["edad"] = isNaN(hoy.diff(naci, "year")) ? '' : hoy.diff(naci, "year");
            var vvv = moment(_detalla["edad"]).format("YYYY-MM-DD");
        }

        setPersonalesApo(_detalla);
    };

    const onInputChangeGlosa = (e) => {
        const val = (e.target && e.target.value) || "";
        let _detalla = { ...glosa };
        _detalla["glosa"] = val;
        setGlosa(_detalla);
    };

    const checkFicha = (value) => {
        if (!accionPermiso(permisos, "ficha_matricular")) return true;

        if (value.length > 7) return true;

        let array = [];

        value?.map((val, index) => {
            if (val.idmatriculapie <= 0) {
                array.push(val);
            }
        });

        setSelectedFicha(array);
        accionButtonMatricular(array.length);
    };

    const accionButtonMatricular = (length) => {
        if (length > 0) {
            setBtnMatricular(false);
        } else {
            setBtnMatricular(true);
        }
        setLabelCountMatricular(length);
    };

    const viewDetalle = async (personales, es_ver) => {
        ver.current = es_ver;

        dispatch(loading(true));
        var data = await getPersona(personales.idalumno, usuario.token);
        if (data.error == 0) {
            setRegiones(usuario.general.region);
            setRegionesApo(usuario.general.region);
            let personaSelect = { ...DatosPersonales };
            personaSelect.id = data.alumno.idalumno;
            personaSelect.apellido_paterno = data.alumno.apellido_paterno;
            personaSelect.apellido_materno = data.alumno.apellido_materno;
            personaSelect.direccion = data.alumno.direccion;
            personaSelect.email = data.alumno.email == null ? '' : data.alumno.email;

            if (data.alumno.fecha_nacimiento == null) {
                personaSelect.fecha_nacimiento = '';
            } else {

                let fecha_nacimiento = new Date(data.alumno.fecha_nacimiento);
                fecha_nacimiento.setMinutes(fecha_nacimiento.getMinutes() + fecha_nacimiento.getTimezoneOffset());
                personaSelect.fecha_nacimiento = fecha_nacimiento; //new Date(data.alumno.fecha_nacimiento).toUTCString()

            }

            if (data.alumno.fecha_ingreso == null) {
                personaSelect.fecha_ingreso = '';
            } else {
                let fecha_ingreso = new Date(data.alumno.fecha_ingreso);
                fecha_ingreso.setMinutes(fecha_ingreso.getMinutes() + fecha_ingreso.getTimezoneOffset());
                personaSelect.fecha_ingreso = fecha_ingreso; //new Date(data.alumno.fecha_nacimiento).toUTCString()
            }

            if (data.alumno.fecha_retiro == null) {
                personaSelect.fecha_retiro = '';
            } else {
                let fecha_retiro = new Date(data.alumno.fecha_retiro);
                fecha_retiro.setMinutes(fecha_retiro.getMinutes() + fecha_retiro.getTimezoneOffset());
                personaSelect.fecha_retiro = data.alumno.fecha_retiro  //new Date(data.alumno.fecha_nacimiento).toUTCString()
            }

            personaSelect.foto = data.alumno.foto === null ? personaSelect.foto : data.alumno.foto;
            personaSelect.nombres = data.alumno.nombres;
            personaSelect.run = data.alumno.run;
            personaSelect.prioritario = data.alumno.prioritario == 1 ? true : false;
            personaSelect.preferente = data.alumno.preferente == 1 ? true : false;
            personaSelect.telefono = data.alumno.telefono;
            personaSelect.region = data.alumno.idregion == undefined ? "" : usuario.general.region.find((o) => o.idregion === data.alumno.idregion);
            personaSelect.comuna = data.alumno.idcomuna == undefined ? "" : usuario.general.comuna.find((o) => o.idcomuna === data.alumno.idcomuna);
            personaSelect.provincia = data.alumno.idprovincia == undefined ? "" : usuario.general.provincia.find((o) => o.idprovincia === data.alumno.idprovincia);
            personaSelect.pais = usuario.general.pais.find((o) => o.id === data.alumno.idpais);

            personaSelect.genero = generoArray.find((o) => o.code === data.alumno.genero);

            personaSelect.etnia = usuario.general.etnia.find((o) => o.id === data.alumno.idetnia);
            personaSelect.idioma = usuario.general.idioma.find((o) => o.id === data.alumno.ididioma);

            let naci = moment(personaSelect.fecha_nacimiento);
            let hoy = moment(new Date());
            personaSelect.edad = isNaN(hoy.diff(naci, "year")) ? '' : hoy.diff(naci, "year");
            setPersonaEdita({ ...personaSelect });
            setPersonales({ ...personaSelect });

            // Apoderado
            let personaApoSelect = { ...DatosPersonalesApo };
            personaApoSelect.apellido_paterno = data.apoderado.apellido_paterno;
            personaApoSelect.apellido_materno = data.apoderado.apellido_materno;
            personaApoSelect.direccion = data.apoderado.direccion;
            personaApoSelect.email = data.apoderado.email;

            if (data.apoderado.fecha_nacimiento == null) {
                personaApoSelect.fecha_nacimiento = '';
            } else {
                let fecha_nacimientoApo = new Date(data.apoderado.fecha_nacimiento);
                fecha_nacimientoApo.setMinutes(fecha_nacimientoApo.getMinutes() + fecha_nacimientoApo.getTimezoneOffset());
                personaApoSelect.fecha_nacimiento = fecha_nacimientoApo; //new Date(data.alumno.fecha_nacimiento).toUTCString()
            }

            personaApoSelect.idalumno = data.apoderado.idalumno;
            personaApoSelect.idapoderado = data.apoderado.idapoderado;
            personaApoSelect.nombres = data.apoderado.nombres;
            personaApoSelect.run = data.apoderado.run;

            personaApoSelect.telefono1 = data.apoderado.telefono1;
            personaApoSelect.telefono2 = data.apoderado.telefono2;
            personaApoSelect.numero_emergencia = data.apoderado.numero_emergencia;
            personaApoSelect.region = data.apoderado.idregion == undefined ? "" : usuario.general.region.find((o) => o.idregion === data.apoderado.idregion);
            personaApoSelect.comuna = data.apoderado.idcomuna == undefined ? "" : usuario.general.comuna.find((o) => o.idcomuna === data.apoderado.idcomuna);
            personaApoSelect.provincia = data.apoderado.idprovincia == undefined ? "" : usuario.general.provincia.find((o) => o.idprovincia === data.apoderado.idprovincia);

            personaApoSelect.parentesco = usuario.general.parentesco.find((o) => o.id === data.apoderado.idparentesco);
            let naciApo = moment(personaApoSelect.fecha_nacimiento);
            personaApoSelect.edad = isNaN(hoy.diff(naciApo, "year")) ? '' : hoy.diff(naciApo, "year")

            setPersonalesApo({ ...personaApoSelect });

            data.observacion.glosa = data.observacion.glosa == null ? "" : data.observacion.glosa;
            setGlosa({ ...data.observacion });

            setDetalleDialog(true);
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
        dispatch(loading(false));
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <div className="actions">
                    {accionPermiso(permisos, "ficha_editar") ? <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" tooltip="Editar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 10 }} onClick={() => viewDetalle(rowData, false)} /> : ""}
                    {accionPermiso(permisos, "ficha_ver_detalle") ? <Button icon="pi pi-eye" className="p-button-rounded p-button-info p-mr-2" tooltip="Ver" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 10 }} onClick={() => viewDetalle(rowData, true)} /> : ""}
                </div>
            </React.Fragment>
        );
    };

    const onBasicUpload = () => {
        toast.current.show({ severity: "info", summary: "Success", detail: "File Uploaded with Basic Mode" });
    };

    /////  Dialog Matricular

    const hideDialogMatri = () => {
        setDialogMatricula(false);
        setDataMatricula(null);
    };

    const saveMatricula = async () => {
        var dataMatriculaSend = [];
        let index = 0;
        let edit = false;
        dataMatricula.forEach((element) => {
            let d = { adicional: element.adi ? 1 : 0, iddiagnostico: element.diag.iddiagnostico, idmatricula: element.id_ficha, observacion: element.obs };
            dataMatriculaSend[index] = d;
            if (element.edit === true) {
                edit = true;
            }
            index++;
        });

        let data = await RegistroMatricula(dataMatriculaSend, colegio.id, anio.anio, usuario.token);
        if (data.error == 0) {
            toast.current.show({ severity: "success", summary: "OK", detail: "Alumnos Matriculados", life: 3000 });
            hideDialogMatri();
            loadFicha();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }

    };

    const onRowEditInit = (event) => {
        originalRows[event.index] = { ...dataMatricula[event.index] };
    };

    const onRowEditCancel = (event) => {
        let products = [...dataMatricula];
        products[event.index] = originalRows[event.index];
        delete originalRows[event.index];
        setDataMatricula(products);
    };

    const matriculaDialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialogMatri} />
            <Button label="Registrar" icon="pi pi-check" onClick={saveMatricula} />
        </>
    );

    const subirFoto = async (files) => {
        dispatch(loading(true));
        var data = await setUploadFoto(personales.id, files.files[0], usuario.token);
        if (data.error == 0) {
            let _detalla = { ...personales };
            _detalla["foto"] = data.url;
            setPersonales(_detalla);
            toast.current.show({ severity: "success", summary: "OK", detail: "Foto subido con éxito!", life: 3000 });
            files.options.clear();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
        dispatch(loading(false));
    };

    const rowClass = (data) => {
        return {
            "row-accessories": data.idmatriculapie > 0,
        };
    };

    const chooseOptions = { label: "Adjuntar" };
    const uploadOptions = { label: "Guardar", icon: "pi pi-upload", className: "p-button-success" };
    const cancelOptions = { label: "Cancelar", icon: "pi pi-times", className: "p-button-danger" };

    const headerKeys = Object.keys(Object.assign({}, ...array));

    const renderFooter = () => {
        return (
            <div>
                {subir ? <Button label="Subir" icon="pi pi-upload" onClick={() => uploadAlumnos()} /> : ""}
                <Button label="Cerrar" icon="pi pi-times" onClick={() => setDisplayResponsive(false)} autoFocus />
            </div>
        );
    }

    const renderFooterPri = () => {
        return (
            <div>
                {subir ? <Button label="Subir" icon="pi pi-upload" onClick={() => uploadAlumnosPriPre('cargar-prioritario')} /> : ""}
                <Button label="Cerrar" icon="pi pi-times" onClick={() => setDisplayResponsivePri(false)} autoFocus />
            </div>
        );
    }

    const renderFooterPre = () => {
        return (
            <div>
                {subir ? <Button label="Subir" icon="pi pi-upload" onClick={() => uploadAlumnosPriPre('cargar-preferente')} /> : ""}
                <Button label="Cerrar" icon="pi pi-times" onClick={() => setDisplayResponsivePre(false)} autoFocus />
            </div>
        );
    }

    useEffect(() => {
        if (displayResponsive) {
            const seen = new Set();
            let duplicadoEncontrado = false;
            array.forEach(item => {
                if (seen.has(item.run_alumno)) {
                    duplicadoEncontrado = true;
                    return;
                }
                seen.add(item.run_alumno);
            });

            if (array.length > 0 && !duplicadoEncontrado) {
                setSubir(true);
            } else {
                setSubir(false);
            }
        } else {
            if (array.length > 0) {
                setSubir(true);
            }
        }

    }, [array]);

    const csvFileToArray = async (string, columnToCheck) => {
        return new Promise(async (resolve, reject) => {
            const csvHeader = string.slice(0, string.indexOf("\n")).split(";");
            const csvRows = string.slice(string.indexOf("\n") + 1).split("\n").filter(row => row.trim() !== "");;

            let allRecords = [];
            let seenRecords = new Map();
            let duplicateColors = {};
            const codeCounts = {};
            let i = 0;
            for (let row of csvRows) {
                const values = row.split(";");
                const obj = csvHeader.reduce((object, header, index) => {
                    object[header] = values[index];
                    return object;
                }, {});

                if (obj['porcentaje_asistencia'] !== '100') {
                    const columnValue = obj[columnToCheck];
                    allRecords.push(obj);
                    codeCounts[columnValue] = (codeCounts[columnValue] || 0) + 1;
                }

            }

            allRecords.forEach(obj => {
                if (codeCounts[obj[columnToCheck]] > 1) {
                    obj['isDuplicate'] = true;

                    if (!duplicateColors[obj[columnToCheck]]) {
                        duplicateColors[obj[columnToCheck]] = getRandomColor();
                    }

                    obj['color'] = duplicateColors[obj[columnToCheck]];

                } else {
                    obj['isDuplicate'] = false;
                }
            });

            // Mover los registros duplicados al inicio de la lista
            const sortedRecords = allRecords.sort((a, b) => {

                if (a.isDuplicate && !b.isDuplicate) {
                    return -1;
                }

                if (!a.isDuplicate && b.isDuplicate) {
                    return 1;
                }

                if (a[columnToCheck] > b[columnToCheck]) {
                    return 1;
                }

                if (a[columnToCheck] < b[columnToCheck]) {
                    return -1;
                }

                return 0;
            });

            resolve(sortedRecords);
        });
    };

    const uploadAlumnosPriPre = async (recurso) => {
        if (colegio.id !== undefined && anio.anio !== undefined) {
            setDisplayResponsive(false);
            dispatch(loading({ estado: true, mensaje: "Importando Alumnos" }));
            var data = await getImportarAlumnosPrePri(recurso, anio.anio, colegio.id, usuario.token, fileUpload.current);
            if (data.error == 0) {
                loadFicha();
                toast.current.show({ severity: "success", summary: "OK", detail: "Alumnos Importados!", life: 3000 });
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, sticky: true });
                } else {
                    console.log("Error");
                }
            }

            dispatch(loading(false));
        }
    }
    const uploadAlumnos = async () => {

        if (colegio.id !== undefined && anio.anio !== undefined) {
            try {
                setDisplayResponsive(false);
                dispatch(loading({ estado: true, mensaje: "Importando Alumnos" }));
                const arrayEnvio = array.map(({ color, isDuplicate, ...resto }) => resto);
                var data = await getImportarAlumnos(colegio.id, usuario.token, arrayEnvio);
                if (data.error == 0) {

                    let usu = { ...usuario };
                    usu.anios = data.anios;
                    dispatch(setUsuarioLogin(usu));
                    localStorage.setItem('dat', JSON.stringify(usu));
                    loadFicha();
                    toast.current.show({ severity: "success", summary: "OK", detail: "Alumnos Importados!", life: 3000 });
                } else {
                    if (data.error == 1) {
                        toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, sticky: true });
                    } else {
                        console.log("Error");
                    }
                }
            } catch (error) {
                toast.current.show({ severity: "error", summary: "Error", detail: "Error al importar", sticky: true });

            } finally {
                dispatch(loading(false));
            }
        }
    }

    const subirDocumento = (files) => {

        var file = files.files[0];
        fileUpload.current = file;

        if (displayResponsive) {
            if (file.type === 'text/plain' || file.name.endsWith('.txt')) {
                // Procesa archivos de texto (txt)
                leerArchivoTexto(file);
            } else {
                // Archivo no compatible
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Formato de archivo no admitido.', life: 3000 });
            }
        }

        if (displayResponsivePri || displayResponsivePre) {
            if (file.type === 'application/vnd.ms-excel' && file.name.endsWith('.xls')) {
                // Procesa archivos Excel (xls, xlsx)
                leerArchivoHtml(file);
            } else {
                // Archivo no compatible
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Formato de archivo no admitido.', life: 3000 });
            }
        }
    }

    const getRandomColor = () => {
        const letters = 'BCDEF'.split('');
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * letters.length)];
        }
        return color;
    };

    const leerArchivoTexto = (file) => {
        var textType = /text.*/;

        if (file.type.match(textType)) {
            var reader = new FileReader();
            dispatch(loading(true));
            reader.onload = async function (e) {
                console.log('Iniciando carga de archivo...');
                var content = reader.result;
                try {
                    const result = await csvFileToArray(content, "run_alumno");
                    console.log('Procesamiento del archivo completado.');
                    setArray(result);
                    toast.current.show({ severity: "success", summary: "Éxito", detail: "Archivo procesado correctamente.", life: 3000 });
                } catch (error) {
                    console.error("Error al procesar el archivo TXT:", error);
                    toast.current.show({ severity: "error", summary: "Error", detail: "Ocurrió un error al procesar el archivo.", life: 3000 });
                }
                finally {
                    // Una vez completada la operación de lectura, actualizar el estado de carga a false
                    dispatch(loading(false));
                }
            };

            reader.readAsText(file, 'ISO-8859-1');
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Solo se admiten archivos de texto (TXT).', life: 3000 });
        }
    }

    const leerArchivoHtml = (file) => {

        dispatch(loading(true));
        var reader = new FileReader();

        reader.onload = async function (e) {
            var arrayBuffer = e.target.result; // Leer los datos del archivo como texto

            // Decodificar el ArrayBuffer usando ISO-8859-1 (Latin-1)
            var decoder = new TextDecoder("iso-8859-1");
            var data = decoder.decode(arrayBuffer);

            // Parsear el archivo como HTML
            var parser = new DOMParser();
            var doc = parser.parseFromString(data, "text/html");

            // Extraer la tabla del archivo HTML
            var table = doc.querySelector("table");

            if (!table) {
                // Si no hay tabla, muestra un mensaje de error
                if (toast && typeof toast.current === 'object') {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se encontró una tabla en el archivo.', life: 3000 });
                }
                dispatch(loading(false));
                return;
            }

            // Convertir la tabla HTML a un array de objetos (puedes personalizar esto según tu necesidad)
            var rows = Array.from(table.rows).map(row => {
                return Array.from(row.cells).map(cell => cell.textContent.trim());
            });

            // Guardar los datos extraídos
            setArray(rows);

            // Mostrar mensaje de éxito
            if (toast && typeof toast.current === 'object') {
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Archivo HTML procesado correctamente.', life: 3000 });
            }

            dispatch(loading(false));
        };

        // Leer el archivo como texto
        reader.readAsArrayBuffer(file);
    };

    const leerArchivoExcel = (file) => {
        dispatch(loading(true));
        var reader = new FileReader();
        reader.onload = async function (e) {
            var data = e.target.result; // Obtener los datos del archivo
            var workbook = XLSX.read(data, { type: 'array' });
            var sheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[sheetName];
            var excelData = XLSX.utils.sheet_to_json(worksheet, {
                header: 1, raw: false, // Procesar automáticamente los tipos de datos
                defval: ''  // Utilizar cadena vacía como valor predeterminado para celdas vacías
            });

            setArray(excelData);

            if (dispatch && typeof dispatch === 'function') {
                dispatch(loading(false));
            }

            // Mostrar mensajes de éxito o manejar otros escenarios
            if (toast && typeof toast.current === 'object') {
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Archivo Excel procesado correctamente.', life: 3000 });
            }
        };

        reader.readAsArrayBuffer(file);
    };


    const dialogUpload = () => {
        setArray([]);
        setDisplayResponsive(true);
        setSubir(false);
    };

    const dialogUploadPrioritario = () => {
        setArray([]);
        setDisplayResponsivePri(true);
        setSubir(false);
    }

    const dialogUploadPreferente = () => {
        setArray([]);
        setDisplayResponsivePre(true);
        setSubir(false);
    }

    const aceptarTipos = ".txt,.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    const eliminarRegistroDuplicado = (index) => {

        dispatch(loading({ estado: true, mensaje: "Eliminando Registro" }));
        setTimeout(() => {
            setArray(prevArray => prevArray.filter((item, i) => i !== index));
            dispatch(loading(false));
        }, 500);
    };

    const htmlUpload = (
        <>
            <div className="p-col-12 p-md-12 p-lg-12 p-p-0">
                <div width="100%" style={{ textAlign: "left", width: "100%", border: "solid 1px", borderColor: "#dee2e6", padding: "10px", borderRadius: "5px" }}>
                    <span>
                        {colegio.rbd} : {colegio.nombre}
                    </span>
                </div>
                <p></p>
                {subir ? (
                    ""
                ) : (
                    <div width="100%" style={{ textAlign: "center", width: "100%", border: "solid 1px", borderColor: "#dee2e6", padding: "10px", borderRadius: "5px" }}>
                        <FileUpload mode="basic" name="demo1" auto={false} customUpload={true} chooseOptions={chooseOptions} uploadOptions={uploadOptions} uploadHandler={subirDocumento} accept={aceptarTipos} maxFileSize={1000000} />
                    </div>
                )}

                <ScrollPanel style={{ width: "100%", height: "200px" }} className="custombar2">
                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <thead>
                            <tr key={"header"}>
                                {headerKeys.map((key) => (
                                    <th key={key} style={{ border: "solid 1px black", display: (key === 'isDuplicate' || key === 'color') ? 'none' : 'table-cell' }}>{key}</th>
                                ))}

                            </tr>
                        </thead>

                        <tbody>
                            {(() => {
                                const seen = new Set();
                                return array.map((item, i) => {
                                    const isDuplicate = seen.has(item.run_alumno);
                                    seen.add(item.run_alumno);
                                    return (
                                        <tr key={i} style={{ backgroundColor: item.isDuplicate ? item.color : 'white' }}>
                                            {Object.entries(item).map(([key, val], index) => (
                                                <td key={index} style={{ border: "solid 1px black", display: key === 'isDuplicate' || key === 'color' ? 'none' : 'table-cell' }}>
                                                    {val}
                                                </td>
                                            ))}
                                            {item.isDuplicate && (
                                                <td style={{ border: "solid 1px black" }}>

                                                    <Button
                                                        icon="pi pi-trash"
                                                        className="p-button-rounded p-button-danger "
                                                        onClick={() => eliminarRegistroDuplicado(i)}
                                                    />

                                                </td>
                                            )}
                                        </tr>
                                    );
                                });
                            })()}
                        </tbody>


                    </table>
                </ScrollPanel>

            </div>
        </>
    );

    const bodyTemplateActivo = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                <Tag className="p-mr-2" severity={data[props.field] == 1 ? "success" : "warning"} value={data[props.field] == 1 ? "ACTIVO" : "RETIRADO"}></Tag>
            </>
        )
    }

    const formularioAlumno = (
        <>
            <div className="p-formgrid p-grid p-col-12 p-p-0 p-mt-2">
                <div className="p-col-12 p-md-12 p-lg-8 p-p-0">
                    <div className="p-grid p-col-12">
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">PAÍS NATAL</label>
                            <Dropdown disabled={ver.current ? true : false} value={personales.pais} options={countries} onChange={(e) => onInputChange(e, "pais")} optionLabel="pais" filter showClear filterBy="pais" placeholder="Seleccionar..." />
                            {submitted && !personalesValidate.pais.estado && <small className="p-error">{personalesValidate.pais.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">RUN</label>
                            <InputText disabled={ver.current ? true : false} id="name2" type="text" value={personales.run} onChange={(e) => onInputChange(e, "run")} required className={classNames({ "p-invalid": submitted && !personalesValidate.run.estado })} />
                            {submitted && !personalesValidate.run.estado && <small className="p-error">{personalesValidate.run.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">NOMBRES</label>
                            <InputText disabled={ver.current ? true : false} id="name24" type="text" value={personales.nombres} onChange={(e) => onInputChange(e, "nombres")} required className={classNames({ "p-invalid": submitted && !personalesValidate.nombres.estado })} />
                            {submitted && !personalesValidate.nombres.estado && <small className="p-error">{personalesValidate.nombres.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">APELLIDO PATERNO</label>
                            <InputText
                                disabled={ver.current ? true : false}
                                id="email2"
                                type="text"
                                value={personales.apellido_paterno}
                                onChange={(e) => onInputChange(e, "apellido_paterno")}
                                required
                                className={classNames({ "p-invalid": submitted && !personalesValidate.apellido_paterno.estado })}
                            />
                            {submitted && !personalesValidate.apellido_paterno.estado && <small className="p-error">{personalesValidate.apellido_paterno.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">APELLIDO MATERNO</label>
                            <InputText
                                disabled={ver.current ? true : false}
                                id="email2"
                                type="text"
                                value={personales.apellido_materno}
                                onChange={(e) => onInputChange(e, "apellido_materno")}
                                required
                                className={classNames({ "p-invalid": submitted && !personalesValidate.apellido_materno.estado })}
                            />
                            {submitted && !personalesValidate.apellido_materno.estado && <small className="p-error">{personalesValidate.apellido_materno.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">GENERO</label>
                            <Dropdown disabled={ver.current ? true : false} value={personales.genero} onChange={(e) => onInputChange(e, "genero")} options={generoArray} optionLabel="name" placeholder="--" />
                            {submitted && !personalesValidate.genero.estado && <small className="p-error">{personalesValidate.genero.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">REGIÓN</label>
                            <Dropdown disabled={ver.current ? true : false} value={personales.region} options={regiones} onChange={(e) => onInputChange(e, "region")} optionLabel="region" filter showClear filterBy="region" placeholder="Seleccionar..." />
                            {submitted && !personalesValidate.region.estado && <small className="p-error">{personalesValidate.region.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">PROVINCIA</label>
                            <Dropdown disabled={ver.current ? true : false} value={personales.provincia} options={provincias} onChange={(e) => onInputChange(e, "provincia")} optionLabel="provincia" filter showClear filterBy="provincia" placeholder="Seleccionar..." />
                            {submitted && !personalesValidate.provincia.estado && <small className="p-error">{personalesValidate.provincia.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">COMUNA</label>
                            <Dropdown disabled={ver.current ? true : false} value={personales.comuna} options={comunas} onChange={(e) => onInputChange(e, "comuna")} optionLabel="comuna" filter showClear filterBy="comuna" placeholder="Seleccionar..." />
                            {submitted && !personalesValidate.comuna.estado && <small className="p-error">{personalesValidate.comuna.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="txtDireccion">DIRECCIÓN</label>
                            <InputText disabled={ver.current ? true : false} id="txtDireccion" type="text" value={personales.direccion} onChange={(e) => onInputChange(e, "direccion")} required className={classNames({ "p-invalid": submitted && !personalesValidate.direccion.estado })} />
                            {submitted && !personalesValidate.direccion.estado && <small className="p-error">{personalesValidate.direccion.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">EMAIL</label>
                            <InputText disabled={ver.current ? true : false} id="name2" type="text" value={personales.email} onChange={(e) => onInputChange(e, "email")} required className={classNames({ "p-invalid": submitted && !personalesValidate.email.estado })} />
                            {submitted && !personalesValidate.email.estado && <small className="p-error">{personalesValidate.email.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">TELEFONO</label>
                            <InputText disabled={ver.current ? true : false} id="email2" type="text" value={personales.telefono} onChange={(e) => onInputChange(e, "telefono")} required className={classNames({ "p-invalid": submitted && !personalesValidate.telefono.estado })} />
                            {submitted && !personalesValidate.telefono.estado && <small className="p-error">{personalesValidate.telefono.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">FECHA NACIMIENTO</label>
                            <Calendar
                                disabled={ver.current ? true : false}
                                id="spanish"
                                value={personales.fecha_nacimiento}
                                onChange={(e) => onInputChange(e, "fecha_nacimiento")}
                                locale="es"
                                dateFormat="dd/mm/yy"
                                monthNavigator
                                yearNavigator
                                yearRange="1980:2030"
                                showIcon
                                monthNavigatorTemplate={monthNavigatorTemplate}
                                yearNavigatorTemplate={yearNavigatorTemplate}
                            />
                            {submitted && !personalesValidate.fecha_nacimiento.estado && <small className="p-error">{personalesValidate.fecha_nacimiento.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">EDAD</label>
                            <InputText id="txt" type="text" value={personales.edad} disabled />
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">IDIOMA</label>
                            <Dropdown disabled={ver.current ? true : false} value={personales.idioma} onChange={(e) => onInputChange(e, "idioma")} options={usuario.general.idioma} optionLabel="idioma" placeholder="--" />
                            {submitted && !personalesValidate.idioma.estado && <small className="p-error">{personalesValidate.idioma.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">ETNIA</label>
                            <Dropdown disabled={ver.current ? true : false} value={personales.etnia} onChange={(e) => onInputChange(e, "etnia")} options={usuario.general.etnia} optionLabel="descripcion" placeholder="--" />
                            {submitted && !personalesValidate.etnia.estado && <small className="p-error">{personalesValidate.etnia.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">FECHA INGRESO AL CURSO</label>
                            <Calendar
                                disabled={ver.current ? true : false}
                                id="spanish"
                                value={personales.fecha_ingreso}
                                onChange={(e) => onInputChange(e, "fecha_ingreso")}
                                locale="es"
                                dateFormat="dd/mm/yy"
                                monthNavigator
                                yearNavigator
                                yearRange="2000:2030"
                                showIcon
                                monthNavigatorTemplate={monthNavigatorTemplate}
                                yearNavigatorTemplate={yearNavigatorTemplate}
                            />
                            {submitted && !personalesValidate.fecha_ingreso.estado && <small className="p-error">{personalesValidate.fecha_ingreso.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">FECHA DE RETIRO</label>
                            <Calendar
                                disabled={ver.current ? true : false}
                                id="spanish"
                                value={personales.fecha_retiro}
                                onChange={(e) => onInputChange(e, "fecha_retiro")}
                                locale="es"
                                dateFormat="dd/mm/yy"
                                monthNavigator
                                yearNavigator
                                yearRange="2000:2030"
                                showIcon
                                monthNavigatorTemplate={monthNavigatorTemplate}
                                yearNavigatorTemplate={yearNavigatorTemplate}
                            />
                            {submitted && !personalesValidate.fecha_retiro.estado && <small className="p-error">{personalesValidate.fecha_retiro.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-3" style={{ display: 'flex', alignItems: 'center' }}>
                            <InputSwitch disabled={ver.current ? true : false} checked={personales.preferente} onChange={(e) => onInputChange(e, "preferente")} />
                            <label htmlFor="name2" style={{ marginLeft: '10px' }}>Preferente</label>
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-3" style={{ display: 'flex', alignItems: 'center' }}>
                            <InputSwitch disabled={ver.current ? true : false} checked={personales.prioritario} onChange={(e) => onInputChange(e, "prioritario")} />
                            <label htmlFor="name2" style={{ marginLeft: '10px' }}>Prioritario</label>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-12 p-lg-4 p-p-0">
                    <div className="p-grid">
                        <div className="card" width="100%" style={{ textAlign: "center", width: "100%" }}>
                            <h5>Foto:</h5>
                            <Image src={personales.foto} alt="Image" width="250" height="260" />
                            <FileUpload disabled={ver.current ? true : false} mode="basic" name="demo" auto={false} customUpload={true} chooseOptions={chooseOptions} uploadOptions={uploadOptions} uploadHandler={subirFoto} accept="image/*" maxFileSize={1000000} onUpload={onBasicUpload} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    const formularioApoderado = (
        <>
            <div className="p-formgrid p-grid p-col-12 p-p-0 p-mt-2">
                <div className="p-col-12 p-md-12 p-lg-12 p-p-0">
                    <div className="p-grid p-col-12">
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">RUN</label>
                            <InputText disabled={ver.current ? true : false} id="name2" type="text" value={personalesApo.run} onChange={(e) => onInputChangeApo(e, "run")} required className={classNames({ "p-invalid": submittedApo && !personalesApoValidate.run.estado })} />
                            {submittedApo && !personalesApoValidate.run.estado && <small className="p-error">{personalesApoValidate.run.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">NOMBRES</label>
                            <InputText disabled={ver.current ? true : false} id="name24" type="text" value={personalesApo.nombres} onChange={(e) => onInputChangeApo(e, "nombres")} required className={classNames({ "p-invalid": submittedApo && !personalesApoValidate.nombres.estado })} />
                            {submittedApo && !personalesApoValidate.nombres.estado && <small className="p-error">{personalesApoValidate.nombres.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">APELLIDO PATERNO</label>
                            <InputText
                                disabled={ver.current ? true : false}
                                id="email2"
                                type="text"
                                value={personalesApo.apellido_paterno}
                                onChange={(e) => onInputChangeApo(e, "apellido_paterno")}
                                required
                                className={classNames({ "p-invalid": submittedApo && !personalesApoValidate.apellido_paterno.estado })}
                            />
                            {submittedApo && !personalesApoValidate.apellido_paterno.estado && <small className="p-error">{personalesApoValidate.apellido_paterno.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">APELLIDO MATERNO</label>
                            <InputText
                                disabled={ver.current ? true : false}
                                id="email2"
                                type="text"
                                value={personalesApo.apellido_materno}
                                onChange={(e) => onInputChangeApo(e, "apellido_materno")}
                                required
                                className={classNames({ "p-invalid": submittedApo && !personalesApoValidate.apellido_materno.estado })}
                            />
                            {submittedApo && !personalesApoValidate.apellido_materno.estado && <small className="p-error">{personalesApoValidate.apellido_materno.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">REGIÓN</label>
                            <Dropdown disabled={ver.current ? true : false} value={personalesApo.region} options={regionesApo} onChange={(e) => onInputChangeApo(e, "region")} optionLabel="region" filter showClear filterBy="region" placeholder="Seleccionar..." />
                            {submittedApo && !personalesApoValidate.region.estado && <small className="p-error">{personalesApoValidate.region.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">PROVINCIA</label>
                            <Dropdown disabled={ver.current ? true : false} value={personalesApo.provincia} options={provinciasApo} onChange={(e) => onInputChangeApo(e, "provincia")} optionLabel="provincia" filter showClear filterBy="provincia" placeholder="Seleccionar..." />
                            {submittedApo && !personalesApoValidate.provincia.estado && <small className="p-error">{personalesApoValidate.provincia.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">COMUNA</label>
                            <Dropdown disabled={ver.current ? true : false} value={personalesApo.comuna} options={comunasApo} onChange={(e) => onInputChangeApo(e, "comuna")} optionLabel="comuna" filter showClear filterBy="comuna" placeholder="Seleccionar..." />
                            {submittedApo && !personalesApoValidate.comuna.estado && <small className="p-error">{personalesApoValidate.comuna.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="txtDireccion">DIRECCIÓN</label>
                            <InputText disabled={ver.current ? true : false} id="txtDireccion" type="text" value={personalesApo.direccion} onChange={(e) => onInputChangeApo(e, "direccion")} required className={classNames({ "p-invalid": submittedApo && !personalesApoValidate.direccion.estado })} />
                            {submittedApo && !personalesApoValidate.direccion.estado && <small className="p-error">{personalesApoValidate.direccion.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">EMAIL</label>
                            <InputText disabled={ver.current ? true : false} id="name2" type="text" value={personalesApo.email} onChange={(e) => onInputChangeApo(e, "email")} required className={classNames({ "p-invalid": submittedApo && !personalesApoValidate.email.estado })} />
                            {submittedApo && !personalesApoValidate.email.estado && <small className="p-error">{personalesApoValidate.email.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">FECHA NACIMIENTO</label>
                            <Calendar
                                disabled={ver.current ? true : false}
                                id="spanish"
                                value={personalesApo.fecha_nacimiento}
                                onChange={(e) => onInputChangeApo(e, "fecha_nacimiento")}
                                locale="es"
                                dateFormat="dd/mm/yy"
                                monthNavigator
                                yearNavigator
                                yearRange="1980:2030"
                                showIcon
                                monthNavigatorTemplate={monthNavigatorTemplate}
                                yearNavigatorTemplate={yearNavigatorTemplate}
                            />
                            {submittedApo && !personalesApoValidate.fecha_nacimiento.estado && <small className="p-error">{personalesApoValidate.fecha_nacimiento.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">EDAD</label>
                            <InputText id="txt" type="text" value={personalesApo.edad} disabled />
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="name2">PARENTESCO</label>
                            <Dropdown disabled={ver.current ? true : false} value={personalesApo.parentesco} onChange={(e) => onInputChangeApo(e, "parentesco")} options={usuario.general.parentesco} optionLabel="descripcion" placeholder="--" />
                            {submittedApo && !personalesApoValidate.parentesco.estado && <small className="p-error">{personalesApoValidate.parentesco.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">TELÉFONO 1</label>
                            <InputText disabled={ver.current ? true : false} id="email2" type="text" value={personalesApo.telefono1} onChange={(e) => onInputChangeApo(e, "telefono1")} required className={classNames({ "p-invalid": submittedApo && !personalesApoValidate.telefono1.estado })} />
                            {submittedApo && !personalesApoValidate.telefono1.estado && <small className="p-error">{personalesApoValidate.telefono1.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">TELÉFONO 2</label>
                            <InputText id="email2" type="text" value={personalesApo.telefono2} onChange={(e) => onInputChangeApo(e, "telefono2")} required className={classNames({ "p-invalid": submittedApo && !personalesApoValidate.telefono2.estado })} />
                            {submittedApo && !personalesApoValidate.telefono2.estado && <small className="p-error">{personalesApoValidate.telefono2.mensaje}</small>}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                            <label htmlFor="email2">NÚMERO EMERGENCIA</label>
                            <InputText
                                disabled={ver.current ? true : false}
                                id="email2"
                                type="text"
                                value={personalesApo.numero_emergencia}
                                onChange={(e) => onInputChangeApo(e, "numero_emergencia")}
                                required
                                className={classNames({ "p-invalid": submittedApo && !personalesApoValidate.numero_emergencia.estado })}
                            />
                            {submittedApo && !personalesApoValidate.numero_emergencia.estado && <small className="p-error">{personalesApoValidate.numero_emergencia.mensaje}</small>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    return (
        <div className="p-grid table-demo">
            <div className="p-col-12">
                <Toast ref={toast} />

                <DataTable
                    value={dataFichaFilter}
                    selectionMode="checkbox"
                    paginator
                    id="13"
                    className="p-datatable-customers p-datatable-sm"
                    rows={page}
                    dataKey="id"
                    rowHover
                    selection={selectedFicha}
                    onSelectionChange={(e) => checkFicha(e.value)}
                    globalFilter={globalFilter1}
                    emptyMessage="No existe información!"
                    rowsPerPageOptions={[8, 15, 30]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Reg. {first} - {last} de {totalRecords}"
                    loading={loading1}
                    header={header}
                    size="small"
                    responsiveLayout="scroll"
                    metaKeySelection={true}
                    rowClassName={rowClass}
                >
                    <Column selectionMode="multiple" headerStyle={{ width: "3em" }}></Column>
                    {/*  <Column field="fecha_matricula" header="Fecha" sortable body={bodyTemplateDate}></Column>  */}
                    <Column field="cod_ensenanza" headerStyle={{ width: "3.5rem" }} bodyStyle={{ textAlign: "center"}} header="Código" body={bodyTemplate}></Column>
                        <Column field="grado" headerStyle={{ width: "4rem",textAlign: "center"  }} bodyStyle={{ textAlign: "center" }}  header="Curso" body={bodyTemplate}></Column>
                    <Column field="run" header="Run" sortable body={bodyTemplate}></Column>
                    <Column field="nombres" header="Nombres" sortable body={bodyTemplate}></Column>
                    <Column field="apellido_paterno" header="Paterno" sortable body={bodyTemplate}></Column>
                    <Column field="apellido_materno" header="Materno" sortable body={bodyTemplate}></Column>
                    <Column field="estado_alumno" header="Estado" sortable body={bodyTemplateActivo}></Column>
                    <Column header="Herramientas" headerStyle={{ width: "10rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible", justifyContent: "center" }} body={actionBodyTemplate}></Column>
                </DataTable>

                <Dialog header="Subir Archivo" visible={displayResponsive} onHide={() => setDisplayResponsive(false)} breakpoints={{ "960px": "75vw" }} style={{ width: "80vw" }} footer={renderFooter()}>
                    {htmlUpload}
                </Dialog>

                <Dialog header="Subir Archivo Prioritario" visible={displayResponsivePri} onHide={() => setDisplayResponsivePri(false)} breakpoints={{ "960px": "75vw" }} style={{ width: "60vw" }} footer={renderFooterPri()}>
                    {htmlUpload}
                </Dialog>

                <Dialog header="Subir Archivo Preferente" visible={displayResponsivePre} onHide={() => setDisplayResponsivePre(false)} breakpoints={{ "960px": "75vw" }} style={{ width: "60vw" }} footer={renderFooterPre()}>
                    {htmlUpload}
                </Dialog>

                <Dialog visible={detalleDialog} style={{ width: "80vw" }} breakpoints={{ "960px": "100vw" }} header="Detalle Ficha" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                        <TabPanel header="DATOS PERSONALES">{formularioAlumno}</TabPanel>
                        <TabPanel header="DATOS APODERADO">{formularioApoderado}</TabPanel>
                        <TabPanel header="ADICIONAL">
                            <div className="p-formgrid p-grid p-col-12 p-p-0 p-mt-2">
                                <div className="p-col-12 p-md-12 p-lg-12 p-p-0">
                                    <div className="p-grid p-col-12">
                                        <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                                            <label htmlFor="name2">GLOSA</label>
                                            <InputTextarea
                                                disabled={ver.current ? true : false}
                                                placeholder="Ingrese glosa"
                                                autoResize
                                                rows="3"
                                                cols="30"
                                                value={glosa.glosa}
                                                onChange={(e) => onInputChangeGlosa(e)}
                                                required
                                                className={classNames({ "p-invalid": submittedObse && !glosaValidacion })}
                                            />
                                            {submittedObse && !glosaValidacion && <small className="p-error">Campo Requerido </small>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    </TabView>
                </Dialog>

                <Dialog visible={dialogMatricula} style={{ width: "70%" }} header="Matrícula" modal className="p-fluid" footer={matriculaDialogFooter} onHide={hideDialogMatri}>
                    <div className="datatable-editing-demo">
                        <DataTable value={dataMatricula} id="dat" editMode="row" dataKey="id" onRowEditInit={onRowEditInit} onRowEditCancel={onRowEditCancel} responsiveLayout="scroll">
                            <Column namecol="gr" field="gr" header="Curso" style={{ width: "8%" }}></Column>
                            <Column namecol="no" field="no" header="Nombres" style={{ width: "10%" }}></Column>
                            <Column namecol="pa" field="pa" header="Paterno" style={{ width: "10%" }}></Column>
                            <Column namecol="ma" field="ma" header="Materno" style={{ width: "10%" }}></Column>
                            <Column namecol="nee" field="nee.tipo_nee" header="Tipo NEE" editor={(options) => drowEditorTipoNee(options)} style={{ width: "15%" }}></Column>
                            <Column namecol="diag" field="diag.diagnostico" header="Diagnóstico" editor={(options) => drowEditorDiag(options)} style={{ width: "15%" }}></Column>
                            <Column namecol="obs" field="obs" header="Observación" editor={(options) => textEditor(options)} style={{ width: "20%" }}></Column>
                            <Column namecol="adi" field="adi" header="Adicional" editor={(options) => checkEditorS(options)} body={checkEditor} style={{ width: "10%" }}></Column>
                            <Column rowEditor headerStyle={{ width: "10%", minWidth: "8rem" }} bodyStyle={{ textAlign: "center" }}>
                                {" "}
                            </Column>
                        </DataTable>
                    </div>
                </Dialog>
            </div>
        </div>
    );
};
